import React, { useContext, useEffect, useRef, useState } from 'react'
import { SpecialZoomLevel, Viewer } from '@react-pdf-viewer/core';
import { v4 as uuidv4 } from 'uuid';
import { MessageIcon, highlightPlugin, Trigger } from '@react-pdf-viewer/highlight';

import { ReactComponent as INFO } from "../../assets/icons/Info.svg";
import { ReactComponent as LEFTITEM } from "../../assets/icons/left-item.svg";
import { ReactComponent as RIGHTITEM } from "../../assets/icons/right-item.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as Cross } from "../../assets/icons/x.svg";

import sendDefault from '../../assets/icons/chatIcons/sendDefault.svg';
import sendButton from '../../assets/icons/chatIcons/sendButton.svg';
import { NotificationContext } from '../../Context/NotificationContext';
import NewButton from '../NewButton';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import "@react-pdf-viewer/highlight/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import './AddCommentonDocument.css';
import { auth, fieldValue, firestore, storage } from '../../firebase.config';
import { saveAs } from "file-saver";

const AddCommentonTranslatedFiles = ({ selectedFile, orderInfo, quoteInfo, handleClose, userData }) => {
    const { transitionTo } = useScreenTransition();
    const { showNotification } = useContext(NotificationContext);
    const [documentFile, setDocumentFile] = useState(selectedFile);
    const [message, setMessage] = useState('');
    const [notes, setNotes] = useState([]);
    const viewerRef = useRef(null);
    const notesContainerRef = useRef(null);
    const [moreOptions, setMoreOptions] = useState("");
    const noteElements = new Map();
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [editedNoteContent, setEditedNoteContent] = useState('');
    const [replyTexts, setReplyTexts] = useState({});
    const [sendIcons, setSendIcons] = useState({});
    const user = auth.currentUser;
    const [showGuide, setShowGuide] = useState(false);
    const [hint, setHint] = useState(true);
    console.log("userData--> ", userData.role);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === 'a') {
                event.preventDefault();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    document.addEventListener('keydown', (event) => {
        if (event.ctrlKey && event.key === 'a') {
            event.preventDefault();
        }
    });

    const jumpToNote = (note) => {
        if (!note || !note.highlightAreas || note.highlightAreas.length === 0) {
            return;
        }

        if (viewerRef.current) {
            viewerRef.current.scrollToHighlightArea(note.highlightAreas[0].pageIndex, note.highlightAreas[0]);
        }
    };
    useEffect(() => {
        if (documentFile && documentFile?.id) {
            fetchNotes();
        }
    }, [documentFile]);

    const fetchNotes = () => {
        firestore
            .collection("fileComments")
            .where("fileId", "==", documentFile?.id)

            .onSnapshot((snapshot) => {
                const fetchedNotes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setNotes(fetchedNotes);
            });
    };


    const renderHighlightTarget = (props) => (
        <div
            style={{
                background: '#eee',
                display: 'flex',
                position: 'absolute',
                left: `${props.selectionRegion.left}%`,
                top: `${props.selectionRegion.top + props.selectionRegion.height}%`,
                transform: 'translate(0, 8px)',
                zIndex: 2,
                padding: '5px',
                borderRadius: '5px',
            }}
        >
            <button onClick={props.toggle} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                <MessageIcon />
            </button>
        </div>
    );

    const renderHighlightContent = (props) => {
        if (!props.highlightAreas || props.highlightAreas.length === 0) {
            return null;
        }

        const addNoteToFirestore = async () => {
            if (message.trim() === '' || !props.highlightAreas || props.highlightAreas.length === 0) {
                return;
            }
            let fileId = documentFile?.id;


            if (!fileId) {

                fileId = uuidv4();
                const newFile = {
                    id: fileId,
                    name: documentFile?.name || "Untitled",
                    url: documentFile?.url || "",
                    createdAt: fieldValue.serverTimestamp(),
                };

                await firestore.collection("files").doc(fileId).set(newFile);
                setDocumentFile(prev => ({ ...prev, id: fileId }));
            }


            const newNote = {
                id: uuidv4(),
                content: message,
                fileId: fileId,
                highlightAreas: props.highlightAreas,
                quote: props.selectedText || "No text selected",
                userId: user?.uid || "guest",
                orderId: orderInfo?.id ? orderInfo?.id : (quoteInfo?.id ?? null),
                userName: user?.displayName || "Anonymous",
                timestamp: new Date()
            };

            try {
                // Add note to Firestore
                await firestore.collection("fileComments").doc(newNote.id).set(newNote);

                // Update local state
                setNotes([...notes, newNote]);
                setMessage('');
                props.cancel();

                // ✅ Update order status to "revision" in Firestore
                if (orderInfo?.id) {
                    const orderRef = firestore.collection("orders").doc(orderInfo.id);
                    await orderRef.update({
                        status: "revision"
                    });
                    console.log("✅ Order status updated to 'revision' due to note addition.");
                }

            } catch (error) {
                showNotification("Error", `Failed to add note: ${error.message}`, "error");
            }

        };

        return (
            <div
                style={{
                    background: '#fff',
                    border: '1px solid rgba(0, 0, 0, .3)',
                    borderRadius: '4px',
                    padding: '8px',
                    position: 'absolute',
                    left: `${props.selectionRegion.left}%`,
                    top: `${props.selectionRegion.top + props.selectionRegion.height}%`,
                    zIndex: 3,
                    width: '200px',
                }}
            >
                <textarea
                    rows={3}
                    placeholder="Write a note..."
                    style={{ border: '1px solid rgba(0, 0, 0, .3)', width: '100%' }}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', gap: '5px' }}>
                    <NewButton text="Add" width='100%' onClick={addNoteToFirestore} />
                    <NewButton text="Cancel" back icon={false} whiteBtn width='100%' onClick={props.cancel} />
                </div>
            </div>
        );
    };

    const renderHighlights = (props) => {
        if (!notes || notes.length === 0) return null;
        return (
            <div>
                {notes.map((note) => (
                    <React.Fragment key={note.id}>
                        {note.highlightAreas
                            .filter((area) => area.pageIndex === props.pageIndex)
                            .map((area, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        background: 'yellow',
                                        opacity: 0.4,
                                        ...props.getCssProperties(area, props.rotation),
                                        cursor: 'pointer',
                                        pointerEvents: 'auto',
                                    }}
                                    onClick={() => jumpToNote(note)}
                                    ref={(ref) => noteElements.set(note.id, ref)}
                                />
                            ))}
                    </React.Fragment>
                ))}
            </div>
        );
    };

    const highlightPluginInstance = highlightPlugin({
        trigger: Trigger.TextSelection,
        renderHighlightTarget,
        renderHighlightContent,
        renderHighlights,
    });
    const { jumpToHighlightArea } = highlightPluginInstance;


    const scrollToBottom = () => {
        if (notesContainerRef.current) {
            notesContainerRef.current.scrollTop = notesContainerRef.current.scrollHeight;
        }
    };

    const handleSend = (noteId) => {
        const strippedContent = replyTexts[noteId]?.replace(/<p><br><\/p>/g, '').trim();
        if (!strippedContent) return;


        const newReply = {
            id: uuidv4(),
            text: strippedContent,
            userId: user?.uid || "guest",
            userName: user?.displayName || "Anonymous",
            timestamp: new Date()
        };


        firestore.collection("fileComments").doc(noteId).update({
            replies: fieldValue.arrayUnion(newReply),
        })
            .then(() => {
                console.log("✅ Reply added successfully!");


                setNotes(notes.map(note =>
                    note.id === noteId
                        ? { ...note, replies: [...(note.replies || []), newReply] }
                        : note
                ));


                setReplyTexts(prev => ({ ...prev, [noteId]: "" }));
                setSendIcons(prev => ({ ...prev, [noteId]: sendDefault }));

                scrollToBottom();
            })
            .catch(error => {
                console.log("❌ Error adding reply:", error);
            });
    };

    const handleEditorChange = (content, noteId) => {
        const strippedContent = content.replace(/<p><br><\/p>/g, '').trim();
        const isEmpty = strippedContent.length === 0 || strippedContent === '<br>';

        setReplyTexts(prev => ({ ...prev, [noteId]: isEmpty ? '' : content }));
        setSendIcons(prev => ({ ...prev, [noteId]: isEmpty ? sendDefault : sendButton }));
    };

    const handleEditNote = (noteId, newContent) => {

        if (!newContent.trim()) return;

        firestore.collection("fileComments").doc(noteId).update({
            content: newContent,
            timestamp: new Date(),
        })
            .then(() => {

                setNotes(notes.map(note =>
                    note.id === noteId ? { ...note, content: newContent } : note
                ));
                setEditingNoteId(null);
                showNotification("Success", "Note updated successfully!", "success");
            })
            .catch(error => {
                showNotification("Error", `Failed to update note: ${error.message}`, "error");
            });


    };

    const handleDeleteNote = (noteId) => {
        firestore.collection("fileComments").doc(noteId).delete()
            .then(() => {
                showNotification("Success", "Note deleted successfully!", "success");
                setNotes(notes.filter(note => note.id !== noteId));
            })
            .catch(error => {
                showNotification("Error", `Failed to delete note: ${error.message}`, "error");
            });

    };

    function getInitials(name) {
        const words = name?.trim()?.split(/\s+/) || []
        if (!words.length) {
            return ""
        }
        else if (words.length > 1) {
            return (words[0][0] + words[1][0]).toUpperCase();
        }

        return words[0][0].toUpperCase();
    }

    
    const downloadFile = url => {
        window.open(url, '_blank')
    }
    
    const handleDownloadFile = async () => {
        try {
            if (!documentFile || !documentFile.url) {
                showNotification("Error", "No file available for download.", "error");
                return;
            }
            downloadFile(documentFile.url);
        } catch (error) {
            console.log("Download Error:", error);
            showNotification("Error", "Failed to download file.", "error");
        }
    };
    const onMouseUpHandler = (event) => {
        try {
            const selection = window.getSelection();
            if (!selection || selection.rangeCount === 0) {
                console.log("No valid selection found.");
                return;
            }

            let range;
            try {
                range = selection.getRangeAt(0);
            } catch (error) {
                console.log("Error accessing selection range:", error);
                return;
            }
            if (!range || !range.startContainer || !range.endContainer) {
                console.log("Invalid range: Missing start or end container.");
                return;
            }
            const startNode = range.startContainer;
            const endNode = range.endContainer;
            if (
                startNode.nodeType !== Node.TEXT_NODE ||
                endNode.nodeType !== Node.TEXT_NODE
            ) {
                console.log("Invalid selection: Not a text node.");
                return;
            }
            const selectedText = selection.toString().trim();
            if (!selectedText) {
                console.log("Empty selection, skipping highlight.");
                return;
            }
            if (
                startNode.textContent &&
                range.startOffset > startNode.textContent.length
            ) {
                console.log("Start offset out of bounds.");
                return;
            }

            if (
                endNode.textContent &&
                range.endOffset > endNode.textContent.length
            ) {
                console.log("End offset out of bounds.");
                return;
            }
            if (selectedText.length > 500) {
                console.log("Large selection detected, ignoring (potential Ctrl+A)");
                selection.removeAllRanges();
                return;
            }

            console.log("Valid selection detected:", selectedText);
        } catch (error) {
            console.log(error.message);
            
        }
    };

    const handleCloseHint = () => {
        setHint(false);
    }

    return (
        <div className="addCommentContainer" style={{ userSelect: "none" }}>

            <div className="addCommentHeader" id="addComment_header">
                <div className="logoAuthLogoWrap">
                    <img
                        src={require("../../assets/logo.png")}
                        alt="Logo eVerbary"
                        className="authNavLogo"
                        onClick={() => transitionTo("/")}
                    />
                </div>
                <div className="addCommentHeader_right">
                    <NewButton
                        text={"Download File"}
                        back
                        whiteBtn
                        width={"100px"}
                        customIcon={<DOWNLOAD />}
                        smallPadding
                        onClick={handleDownloadFile}
                    />
                    <div className="addCommentCloseIcon" > <Cross className="addCommentDownloadIcon" onClick={handleClose} /></div>
                </div>
            </div>
            {
                hint && userData.role === 'client' && (<div className="expeditedPlusWrapHeader">
                    <div className="expeditedPlusWrap">
                        <p className="expeditedPlusText">
                            Once you add your first comment the document will be automatically send to revision and we'll review your comments
                        </p>
                    </div>

                    <div className="addCommentCloseIcon" > <Cross className="addCommentDownloadIcon" onClick={handleCloseHint} /></div>

                </div>
                )
            }

            <div className="notePageContainer">
                <div className="noteContainerOptions">
                    <div style={{ display: 'flex', flexDirection: 'column', height: '90vh' }}>
                        <p className='titlePDF'>{documentFile.name}</p>
                        <div style={{ flex: 1, overflowY: 'auto', userSelect: "text" }} onMouseDown={onMouseUpHandler}>
                            <Viewer
                                fileUrl={documentFile.url}
                                plugins={[highlightPluginInstance]}
                                defaultScale={SpecialZoomLevel.PageFit}
                            />
                        </div>
                    </div>
                </div>

                <div className="noteContainerOptions">
                    <div id="mainPrimary" >
                        <p className='titleComments'>Comments</p>
                        {notes.length === 0 && <div className="addCommentDocumentGuideWrap">
                            <p className="addCommentDocumentGuideText">To leave a comment select an area of the document, or just click on the document</p>
                            <div className="addCommentDocumentGuideIcon">
                                <INFO onMouseOver={() => setShowGuide(true)} onMouseOut={() => setShowGuide(false)} onClick={() => setShowGuide(g => !g)} />
                                <div className="addCommentDocumentGuideOverlayWrap" style={{ display: showGuide ? "grid" : "none" }}>
                                    <div className="addCommentDocumentGuideOverlay">
                                        <p className="addCommentDocumentGuideOverlayText">Select an Area</p>
                                        <LEFTITEM />
                                    </div>
                                    <p className="orTextDocument">OR</p>
                                    <div className="addCommentDocumentGuideOverlay">
                                        <h6 className="addCommentDocumentGuideOverlayText">Select a Spot</h6>
                                        <RIGHTITEM />
                                    </div>
                                </div>
                            </div>

                        </div>}
                        <div ref={notesContainerRef} style={{ overflowY: 'auto', height: '85vh' }}>
                            {notes.map((note) => (
                                <div
                                    key={note.id}
                                    style={{ background: 'white', borderRadius: '10px', cursor: 'pointer', padding: '8px', margin: '5px 2px' }}
                                    onClick={() => jumpToHighlightArea(note.highlightAreas[0])}
                                    ref={(ref) => noteElements.set(note.id, ref)}
                                >
                                    <blockquote style={{ borderLeft: '2px solid rgba(0, 0, 0, 0.2)', paddingLeft: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'start', fontSize: '15px' }}>
                                        {note.quote}

                                        <div className="noteIconWrap" onClick={(e) => {
                                            e.stopPropagation(); // Prevents event bubbling
                                            setMoreOptions((prev) =>
                                                prev === note.id ? "" : note.id
                                            );
                                        }}
                                            tabIndex={0} // Enables blur event for accessibility
                                            onBlur={() => setMoreOptions("")}>
                                            {moreOptions === note.id ? <MORESELECTED className="noteIcon" /> :
                                                <MORE className="noteIcon" onClick={(e) => {
                                                    e.stopPropagation(); // Prevents event bubbling
                                                    setMoreOptions((prev) =>
                                                        prev === note.id ? "" : note.id
                                                    );
                                                }} />}
                                            {moreOptions === note.id && (
                                                <div className="noteEditWrap">
                                                    <div className="noteEdit" onClick={() => {
                                                        setEditingNoteId(note.id);
                                                        setEditedNoteContent(note.content);
                                                        setMoreOptions("");
                                                    }}>Edit</div>
                                                    <div className="noteEdit" onClick={() => handleDeleteNote(note.id)}>Delete</div>
                                                </div>
                                            )}
                                        </div>
                                    </blockquote>
                                    {editingNoteId === note.id ? (
                                        <div>
                                            <textarea
                                                value={editedNoteContent}
                                                onChange={(e) => setEditedNoteContent(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    outline: 'none',
                                                    borderColor: 'transparent',
                                                    border: '0px solid #ccc',
                                                    resize: 'none',
                                                    fontSize: '13px',
                                                }}
                                            />
                                            <button onClick={() => handleEditNote(note.id, editedNoteContent)} className='butttonSave'>Save</button>
                                            <button onClick={() => setEditingNoteId(null)} className='butttonCancel'>Cancel</button>
                                        </div>
                                    ) : (
                                        <p style={{ fontSize: '16px', fontFamily: 'Montserrat' }}>{note.content}</p>
                                    )}
                                    <div className="repliesContainer">
                                        {note.replies && note.replies.length > 0 && (
                                            <div className="replySection">
                                                {note.replies.map((reply, index) => {
                                                    const userInitial = getInitials(reply.userName);
                                                    const isCurrentUser = reply.userId === user?.uid;

                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`message-wrapper ${isCurrentUser ? "sent" : "received"}`}
                                                        >

                                                            {!isCurrentUser && (
                                                                <div className="avatar-container">
                                                                    {reply.profilePic?.url ? (
                                                                        <img
                                                                            src={reply.profilePic.url}
                                                                            alt={userInitial}
                                                                            className="avatar"
                                                                        />
                                                                    ) : (
                                                                        <div className="avatar">{userInitial}</div>
                                                                    )}
                                                                    <div className="tooltip left">{reply.userName}</div>
                                                                </div>
                                                            )}
                                                            <div
                                                                className={`message ${isCurrentUser ? "sent-message" : "received-message"}`}
                                                            >
                                                                <p>{reply.text}</p>
                                                            </div>
                                                            {isCurrentUser && (
                                                                <div className="avatar-container">
                                                                    {reply.profilePic?.url ? (
                                                                        <img
                                                                            src={reply.profilePic.url}
                                                                            alt={userInitial}
                                                                            className="avatar"
                                                                        />
                                                                    ) : (
                                                                        <div className="avatar">{userInitial}</div>
                                                                    )}
                                                                    <div className="tooltip right">{reply.userName}</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                    <div className="noteDisplayContainer">
                                        <div className="editor-container" style={{ display: 'flex', alignItems: 'center', }}>
                                            <textarea
                                                value={replyTexts[note.id] || ""}
                                                onChange={(e) => handleEditorChange(e.target.value, note.id)}
                                                placeholder="Message...."
                                                style={{
                                                    width: "100%",
                                                    outline: "none",
                                                    borderColor: "transparent",
                                                    border: "0px solid #ccc",
                                                    resize: "none",
                                                    fontSize: "13px",
                                                }}
                                            />
                                            <button
                                                className="send-button"
                                                onClick={() => handleSend(note.id)}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <img src={sendIcons[note.id] || sendDefault} alt="Send" className="send-icon" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AddCommentonTranslatedFiles
